import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../components/AppShell/styles";

/* On mobile the list and its surrounding content use a tighter 20px gutter */
const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

export const Container = styled.div`
  @media ${MOBILE} {
    .float-banner {
      padding-right: 20px;
      padding-left: 20px;
    }

    .float-banner:not(.draft-available) {
      padding-top: 20px;
    }
  }
`;

export const HeaderBox = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid var(--color-neutral-dark);

  .greeting {
    flex: 1;
    min-width: 0;
    text-align: right;
  }

  /* On desktop the logo and greeting live in the sidebar */
  @media (min-width: ${DESKTOP_BREAKPOINT}) {
    display: none;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const SitesSection = styled.div`
  display: grid;
  /* minmax(0, …) lets long Keepo titles truncate instead of widening the column */
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

/* Extra "Create Keepo" row at the end of the list, same height as a Keepo card */
export const NewSiteCard = styled.button`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  padding: 0.75rem 1rem;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-neutral-150);
  border: 2px dashed var(--color-neutral-base);
  border-radius: 1rem;
  transition:
    border-color 0.15s,
    color 0.15s;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: var(--color-neutral-dark);
    border-radius: 100%;
  }

  &:hover {
    color: var(--color-neutral-white);
    border-color: var(--color-neutral-light);
  }

  @media (min-width: ${DESKTOP_BREAKPOINT}) {
    min-height: 72px;
  }
`;

/** The Keepo loader under the list while the next page of Keepos comes. */
export const LoadingMore = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.5rem 0 2rem;
`;
